
// filepath: /Users/faragbuograra/Documents/GitHub/whatsapp_api_backend/client/src/components/GroupPage.js
import React, { useState, useEffect } from "react";
import { t } from "../i18n";
import fetchData from "../api/fetchApi";

export default function GroupPage() {
  const [groupName, setGroupName] = useState("");
  const [groups, setGroups] = useState([]);
  const [editingGroupIdx, setEditingGroupIdx] = useState(null);
  const [editingGroupName, setEditingGroupName] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    fetchData("user/groups")
      .then((data) => setGroups(Array.isArray(data) ? data : []))
      .catch(() => setGroups([]));
  }, []);

  const handleCreateGroup = async (e) => {
    e.preventDefault();
    setSuccess("");
    setError("");
    try {
      await fetchData(
        "user/group",
        "POST",
        JSON.stringify({ name: groupName })
      );
      setSuccess(`${t("success")}: ${groupName} ${t("group-created")}`);
      const data = await fetchData("user/groups");
      setGroups(Array.isArray(data) ? data : []);
      setGroupName("");
    } catch (err) {
      setError(err.message || "فشل إنشاء المجموعة");
    }
  };

  const handleEditGroup = (idx) => {
    setEditingGroupIdx(idx);
    setEditingGroupName(groups[idx].name);
  };

  const handleSaveGroupName = async (idx) => {
    if (!editingGroupName.trim()) return;
    try {
      const group = groups[idx];
      await fetchData(
        "user/group",
        "PUT",
        JSON.stringify({
          uuid: group.uuid,
          name: editingGroupName,
        })
      );
      const data = await fetchData("user/groups");
      setGroups(Array.isArray(data) ? data : []);
      setSuccess("تم تعديل اسم المجموعة بنجاح");
    } catch (err) {
      setError(err.message || "فشل تعديل اسم المجموعة");
    }
    setEditingGroupIdx(null);
    setEditingGroupName("");
  };

  const handleCancelEdit = () => {
    setEditingGroupIdx(null);
    setEditingGroupName("");
  };

  return (
    <div className="bg-white  p-6 rounded-xl shadow  mb-8">
      <form
        onSubmit={handleCreateGroup}
        className="bg-white  p-6 rounded-xl shadow  mb-8"
      >
        <div className="font-semibold mb-2">
          {t("create-group") || "إنشاء مجموعة جديدة"}
        </div>
        <input
          type="text"
          className="w-full border rounded px-3 py-2  "
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
          placeholder={t("group-name") || "اسم المجموعة"}
          required
        />
        <div className="text-sm text-gray-500 mb-2 justify-end text-left">
          <button
            type="submit"
            className="bg-[#013D4E] text-white px-4 py-2 m-1 rounded hover:bg-indigo-700"
          >
            {t("add") || "إضافة"}
          </button>
        </div>
      </form>
      <div className="bg-white  p-6 rounded-xl shadow  mb-8">
        <h3 className="text-lg font-semibold mb-2">
          {t("groups-list") || "قائمة المجموعات"}
        </h3>
        <div className="overflow-x-auto"></div>
        <table className="min-w-full bg-white border rounded">
          <thead>
            <tr>
              <th className="px-4 py-2 border-b text-right">
                {t("group-name") || "اسم المجموعة"}
              </th>
              <th className="px-4 py-2 border-b text-right">
                {t("group-members") || "أعضاء المجموعة"}
              </th>
              <th className="px-4 py-2 border-b text-right">تعديل</th>
            </tr>
          </thead>
          <tbody>
            {groups?.length === 0 ? (
              <tr>
                <td colSpan={3} className="text-center py-4 text-gray-500">
                  {t("no-data")}
                </td>
              </tr>
            ) : (
              groups?.map((group, idx) => (
                <tr key={idx}>
                  <td className="px-4 py-2 border-b">
                    {editingGroupIdx === idx ? (
                      <div className="flex items-center gap-2">
                        <input
                          type="text"
                          className="border rounded px-2 py-1"
                          value={editingGroupName}
                          onChange={(e) => setEditingGroupName(e.target.value)}
                        />
                        <button
                          className="text-green-600 font-bold"
                          onClick={() => handleSaveGroupName(idx)}
                          type="button"
                        >
                          حفظ
                        </button>
                        <button
                          className="text-gray-500 font-bold"
                          onClick={handleCancelEdit}
                          type="button"
                        >
                          إلغاء
                        </button>
                      </div>
                    ) : (
                      group.name
                    )}
                  </td>
                  <td className="px-4 py-2 border-b">{group?.partents}</td>
                  <td className="px-4 py-2 border-b">
                    {editingGroupIdx !== idx && (
                      <button
                        className="text-blue-600 underline"
                        onClick={() => handleEditGroup(idx)}
                        type="button"
                      >
                        تعديل الاسم
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {(success || error) && (
        <div
          className={`mt-4 text-center ${
            success ? "text-green-600" : "text-red-600"
          }`}
        >
          {success || error}
        </div>
      )}
    </div>
  );
}


